import { env } from '@lcsc-ui/utils/baseUrl';
import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';

let opServe = Domains.lcscOpUrl;
if (env === 'local') {
  opServe = 'https://devop.szlcsc.com';
}

export function getNewsList(isMro, params) {
  return sendAxios({
    method: 'get',
    url: isMro ? `/mro/news/list` : `/news/list`,
    baseURL: opServe,
    params,
  });
}
export function getNewsListByPage(isMro, pageNum, params) {
  return sendAxios({
    method: 'get',
    url: isMro ? `/mro/news/list/${pageNum}` : `/news/list/${pageNum}`,
    baseURL: opServe,
    params,
  });
}
export function getInfoListByPage(isMro, pageNum, pathName, params) {
  return sendAxios({
    method: 'get',
    url: isMro ? `/mro/${pathName}/list/${pageNum}` : `/${pathName}/list/${pageNum}`,
    baseURL: opServe,
    params,
  });
}
export function getInfoList(isMro, params) {
  return sendAxios({
    method: 'get',
    url: isMro ? `/mro/info/list` : `/info/list`,
    baseURL: opServe,
    params,
  });
}
export function getInfoDetail(isMro, id, params) {
  return sendAxios({
    method: 'get',
    url: isMro ? `/mro/info/${id}` : `/info/${id}`,
    baseURL: opServe,
    params,
  });
}
// 详情阅读量+1
export function addReadCount(params) {
  return sendAxios({
    method: 'get',
    url: '/add/read/count',
    baseURL: opServe,
    params,
  });
}
